/* eslint-disable max-len */

export type TopDishType = {
    title: {
        firstLine: string,
        secondLine: string,
    },
    description: string
}
export type TopDishesRecord = Record<string, TopDishType>

export const topDishes: TopDishesRecord = {
    25: {
        title: {
            firstLine: 'Вкуснейший',
            secondLine: 'Том ям за 15 минут',
        },
        description: 'Сварили бульон, нашли специи и заправки из Тайланда и добавили много морепродуктов, чтобы вы приготовили тот самый тайский суп дома, как в ресторане.',
    },
    borsch: {
        title: {
            firstLine: '',
            secondLine: '',
        },
        description: '',
    },
    cinnabons: {
        title: {
            firstLine: '',
            secondLine: '',
        },
        description: '',
    },
    lanagna: {
        title: {
            firstLine: '',
            secondLine: '',
        },
        description: '',
    },
};
